<template>
  <bottom-popover :show="popoverShow" @update:show="handleClose">
    <div class="title">
      <p class="title-text">
        <img class="icon" src="../assets/icons/icon_ship4.png" alt="">
        <span>请选择您要预订活动的舱房</span>
      </p>
    </div>
    <div class="room-list">
      <div
        class="room-item"
        v-for="(item, roomIndex) in roomList"
        :key="item.id"
        @click="handleChangeRoom(roomIndex)">
        <img class="icon-check" src="../assets/icons/icon_check2.png" alt="">
        <p class="room-number"><span>舱房号：{{item.stateroomNumber}}</span>订单号：{{item.bookingId}}</p>
        <p class="room-number ship-info"><span>船名：{{item.shipName}}</span>航次：{{item.stringSailDate}}</p>
        <div class="passengers">
          <div class="passenger-side" v-for="(sideItem, sideIndex) in item.bookingGuests" :key="`side${sideIndex}`">
            <p class="passenger-item el" v-for="passenger in sideItem" :key="passenger.id">乘客{{passenger.index}} <span>{{passenger.chineseLastName !== null && passenger.chineseFirstName !== null ? `${passenger.chineseLastName}${passenger.chineseFirstName}` : `${passenger.pinYinLastName}${passenger.pinYinFirstName}`}}</span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-box">
      <div class="btn-item" @click="handleChooseLater">稍后选择</div>
      <div class="btn-item jump btn-linear-gradient" @click="toBindTicket">其他舱房</div>
    </div>
  </bottom-popover>
</template>

<script>
import BottomPopover from '@/components/BottomPopover'
import api from '@/api'
import { showLoading, hideLoading, showToast, showAlert } from '@/utils/tools'
import { getShoppingCartNum, getSmShoppingCartNum } from '@/plugins/common'
import dayjs from 'dayjs'
import pick from 'lodash/pick'

export default {
  name: 'ChangeBookingRecordModels',

  components: {
    BottomPopover
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      roomList: [],
      popoverShow: false,
      currentIndex: -1,
      currentIndexBack: -1
    }
  },

  watch: {
    show (flag) {
      if (flag) {
        this.getBookingRecordModels()
      } else {
        this.popoverShow = false
      }
    }
  },

  computed: {
    isIndex () {
      return this.$route.path === '/Rccl.Pcp/Home/Index'
    }
  },

  methods: {
    async handleChangeRoom (index) {
      this.currentIndexBack = index
      const currentRoom = this.roomList[index]
      showLoading('提交中...')
      const { errCode, errMsg } = await api.loginAndBindingFromBookingMiniApp({
        accessToken: this.$store.state.token,
        sailDate: currentRoom.stringSailDate,
        ...pick(currentRoom, ['bookingId', 'shipCode'])
      })
      hideLoading()
      if (errCode === 0) {
        this.getBookingInfo()
        this.$router.replace('/')
      } else {
        showAlert(errMsg || '绑定失败，请稍后重试')
      }
    },
    async getBookingInfo () {
      showLoading()
      const { errCode, errMsg, data } = await api.getBookingInfo()
      if (errCode === 0) {
        await getShoppingCartNum()
        await getSmShoppingCartNum()
      }
      hideLoading()
      if (errCode === 0) {
        this.currentIndex = this.currentIndexBack
        showToast.success('绑定成功')
        this.$store.commit('updateBindTicket', {
          ...data,
          bookingRemind: `您的行前预订功能将于 ${dayjs(data.sailDateBegin).subtract(3, 'd').format('YYYY年MM月DD日')} 11:59pm 截止`
        })
        this.$store.commit('setBookingContactInfo', data.bookingContact)
        this.handleClose()
        if (!this.isIndex) this.$router.back()
      } else {
        showAlert(errMsg || '绑定失败，请稍后重试')
      }
    },
    async getBookingRecordModels () {
      const { bookingId, shipCode, sailDate } = this.$route.query
      showLoading()
      const { data } = await api.getBookingsByBookingOrderId({
        accessToken: this.$store.state.token,
        bookingId,
        shipCode,
        sailDate
      })
      hideLoading()
      if (data && data.bookingRecordModels !== null && data.bookingRecordModels.length > 0) {
        this.roomList = data.bookingRecordModels.length ? data.bookingRecordModels.map(({ stateroomNumber, bookingId, shipName, shipCode, stringSailDate, bookingGuests }) => ({
          stateroomNumber,
          bookingId,
          shipName,
          shipCode,
          stringSailDate,
          bookingGuests: bookingGuests.length ? this.guestsFormat(bookingGuests) : []
        })) : []
        this.popoverShow = true
      } else {
        this.handleClose()
      }
    },
    toBindTicket () {
      this.handleClose()
      if (this.isIndex) this.$router.push('/bind_ticket?noPopup=true')
    },
    handleClose () {
      this.$emit('update:show', false)
    },
    handleChooseLater () {
      this.handleClose()
      if (!this.isIndex) this.$router.back()
    },
    guestsFormat (guests) {
      // 追加序号
      guests = guests.map((x, i) => ({ ...x, index: i + 1 }))
      if (guests.length <= 2) return [guests]
      return [guests.filter((x, i) => i < guests.length / 2), guests.filter((x, i) => i >= guests.length / 2)]
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  padding: 16px 40px 0;
  font-size: 28px;
  color: #666;
  line-height: 58px;
  .title-text {
    display: flex;
    align-items: center;
    color: #1174b8;
    .icon {
      flex: none;
      width: 38px;
      margin-right: 9px;
    }
  }
}
.room-list {
  max-height: 638px;
  overflow-y:  auto;
  .room-item {
    position: relative;
    width: 670px;
    margin: 15px auto 20px;
    padding: 14px 50px 4px;
    box-sizing: border-box;
    border: 1Px solid #eaeaea;
    border-radius: 10px;
    font-size: 28px;
    line-height: 54px;
    &.active {
      border-color: #1174b8;
      .icon-check {
        display: block;
      }
    }
    .icon-check {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      display: none;
      width: 66px;
      height: auto;
    }
    .room-number {
      display: flex;
      align-items: center;
      color: #1174b8;
      .el;
      &.ship-info {
        color: #333;
      }
      span {
        flex: none;
        width: 48%;
        margin-right: 2%;
      }
    }
    .passengers {
      display: flex;
      .passenger-side {
        flex: none;
        width: 48%;
        line-height: 50px;
        &:last-child {
          margin-left: 2%;
          margin-right: 0;
        }
        &:first-child {
          margin-right: 2%;
          margin-left: 0;
        }
        .passenger-item {
          margin-bottom: 10px;
          color: #999;
          span {
            color: #333;
          }
        }
      }
    }
  }
}
.btn-box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 10px 30px 30px;
  .btn-item {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 325px;
    height: 88px;
    border-radius: 5px;
    font-size: 30px;
    color: #fff;
    background-color: #1174b8;
    &.jump {
      color: #333;
    }
  }
}
</style>
